module.exports = __webpack_public_path__ + "img/infibo-logo-inversed.9ea4485c.svg";